import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://www.museshaircwb.com/wp-content/uploads/2024/01/cropped-Muses-Hair-Logo-1.png"
              alt="Muses Hair CWB"
              className="h-11 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Professional solution center for hair and scalp problems in Causeway Bay, Hong Kong.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm">About</Link></li>
              <li><Link to="/qualifications" className="text-gray-300 hover:text-white transition-colors text-sm">Qualifications</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors text-sm">Services</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6">More</h4>
            <ul className="space-y-3">
              <li><Link to="/products" className="text-gray-300 hover:text-white transition-colors text-sm">Products</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-white transition-colors text-sm">Testimonials</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://www.instagram.com/museshaircwb" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/museshaircwb" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://wa.me/message/YAZZ2YL77SHLN1" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors text-sm">
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-sm">
            &copy; 2024 Muses Hair CWB. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
